import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import Wrapper from "components/Card/Wrapper";
import Required from "components/common/Required";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SNACKBAR_OPEN } from "store/actions";
import { gridSpacing } from "store/constant";
import Loader from "ui-component/Loader";
import axiosServices from "utils/axiosServices";

import { serializeValidData } from "utils/Helpers";
import langString from "utils/langString";
import * as Yup from "yup";

export default function AddService() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      try {
        const response = await axiosServices.post(
          `products/services/unit/list`
        );
        if (response.status === 200) {
          // const respData = await new Deserializer({
          //   keyForAttribute: "camelCase",
          // }).deserialize(response.data);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    };
    init();
  }, []);

  const [upazila, setUpazila] = useState<any>([]);
  useEffect(() => {
    const fetchData = async () => {
      const res = await axiosServices.get("/upazila/getAllUpazila");
      setUpazila(res?.data);
    };
    fetchData();
  }, []);
  console.log("upppppppppp", upazila);

  return (
    <Wrapper
      title={`${langString("add")} ${langString("zone")}`}
      backLink="/public/zone"
    >
      {loading && <Loader />}
      <Formik
        initialValues={{
          name: "",
          latitude: "",
          longitude: "",
          description: "",
          submit: null,
          upazilaId: "",
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required("Name is required"),
          longitude: Yup.string().required("Longitude is required"),
          latitude: Yup.string().required("Latitude is required"),
          upazilaId: Yup.string().required("Upazila Id is required"),
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            const selectedUpazila = upazila.find(
              (item: any) => item.uuid === values.upazilaId
            );
            const upazilaName = selectedUpazila ? selectedUpazila.name : "";

            setLoading(true);
            const postData = serializeValidData("zones", {
              zone: {
                name: values.name,
                latitude: values.latitude,
                longitude: values.longitude,
                description: values.description,
                upazilaId: values.upazilaId,
                upazilla: upazilaName,
              },
            });
            console.log("postData=", postData);

            const response = await axiosServices.post("zone/create", postData);
            console.log("add zone data = ", response);
            if (response.status === 201) {
              dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: "Zone Added Successfully",
                variant: "alert",
                alertSeverity: "success",
              });
              navigate("/public/zone", { replace: true });
            }
            setLoading(false);
          } catch (err: any) {
            dispatch({
              type: SNACKBAR_OPEN,
              open: true,
              message: "Zone Added Failed",
              variant: "alert",
              alertSeverity: "error",
            });
            setLoading(false);
            setStatus({ success: false });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <form noValidate onSubmit={handleSubmit}>
            <Box
              sx={{ border: "1px solid #EEE", padding: 3, borderRadius: 3 }}
              style={{ border: "2px solid red" }}
            >
              <Grid container spacing={gridSpacing}>
                <Grid item xs={6} md={3}>
                  <Typography
                    variant="h5"
                    sx={{ marginTop: 2, textAlign: "right" }}
                  >
                    Upazila Name <Required />
                  </Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  <FormControl
                    fullWidth
                    error={Boolean(touched.name && errors.name)}
                  >
                    <TextField
                      select
                      label="Select Upazila"
                      name="upazilaId"
                      value={values.upazilaId}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      variant="outlined"
                    >
                      {upazila.map((item: any) => (
                        <MenuItem key={item.id} value={item.uuid}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>
                    {touched.upazilaId && errors.upazilaId && (
                      <FormHelperText error>{errors.upazilaId}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={gridSpacing} sx={{ marginTop: "5px" }}>
                <Grid item xs={6} md={3}>
                  <Typography
                    variant="h5"
                    sx={{ marginTop: 2, textAlign: "right" }}
                  >
                    Zone Name <Required />
                  </Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  <FormControl
                    fullWidth
                    error={Boolean(touched.name && errors.name)}
                  >
                    <TextField
                      id="outlined-adornment-name-user-create"
                      type="text"
                      label={"Zone Name"}
                      value={values.name}
                      name="name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                    {touched.name && errors.name && (
                      <FormHelperText
                        error
                        id="standard-weight-helper-text-name-user-create"
                      >
                        {errors.name}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={gridSpacing} sx={{ marginTop: "5px" }}>
                <Grid item xs={6} md={3}>
                  <Typography
                    variant="h5"
                    sx={{ marginTop: 2, textAlign: "right" }}
                  >
                    {langString("Description")}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  <FormControl fullWidth>
                    <TextField
                      id="outlined-adornment-name-user-create"
                      type="text"
                      label={langString("Description")}
                      value={values.description}
                      name="description"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={gridSpacing} sx={{ marginTop: "5px" }}>
                <Grid item xs={6} md={3}>
                  <Typography
                    variant="h5"
                    sx={{ marginTop: 2, textAlign: "right" }}
                  >
                    {langString("Location Mark")} <Required />
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <FormControl
                    fullWidth
                    error={Boolean(touched.latitude && errors.latitude)}
                  >
                    <TextField
                      label={langString("Latitude")}
                      id="outlined-adornment-quantity-user-create"
                      value={values.latitude}
                      type="text"
                      name="latitude"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                    />
                    {touched.latitude && errors.latitude && (
                      <FormHelperText
                        error
                        id="standard-weight-helper-text-name-user-create"
                      >
                        {errors.latitude}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={4} md={3}>
                  <FormControl fullWidth>
                    <TextField
                      label={langString("Longitude")}
                      id="outlined-adornment-quantity-user-create"
                      value={values.longitude}
                      type="text"
                      name="longitude"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                    />
                    {touched.longitude && errors.longitude && (
                      <FormHelperText
                        error
                        id="standard-weight-helper-text-name-user-create"
                      >
                        {errors.longitude}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={gridSpacing}
                sx={{ marginTop: "5px" }}
              ></Grid>

              {errors.submit && (
                <Box sx={{ mt: 3 }}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Box>
              )}
              <Box sx={{ textAlign: "right", paddingTop: 3 }}>
                <Button
                  color="warning"
                  disabled={isSubmitting}
                  size="large"
                  type="button"
                  onClick={() => navigate("/public/zone", { replace: true })}
                  variant="contained"
                  sx={{ marginRight: 2 }}
                >
                  {langString("cancel")}
                </Button>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  {langString("save")}
                </Button>
              </Box>
            </Box>
          </form>
        )}
      </Formik>
    </Wrapper>
  );
}
